export default __webpack_public_path__ + "static/media/working-mom.39eb8b6d.webp";